export default "__VITE_ASSET__BjRkpISX__"